export default __webpack_public_path__ + "slices/main/assets/public/fonts/tiempos/tiempos-headline-medium.e0aa3b190ca79e9287063036a80e34f9.woff";